import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {RolesEnum} from '../core/security/roles.enum';
import {ModulesEnum} from '../core/security/modules.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {ContactListComponent} from './list/list.component';
import {ContactEditComponent} from './contact-edit/contact-edit.component';
import {ContactIntegrationComponent} from './contact-integration/contact-integration.component';

export const routes: Routes = [
  {
    path: 'list',
    component: ContactListComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ContactGroup,
      package: [ModulesEnum.ContactModule, ModulesEnum.PrivateContactModule],
      permissions: [RolesEnum.CompanyContact_View, RolesEnum.CompanyContact_Edit, RolesEnum.CompanyContact_Delete,
        RolesEnum.PrivateContact_View, RolesEnum.PrivateContact_Edit, RolesEnum.PrivateContact_Delete
      ],
      meta: {
        title: 'Contacts',
        override: true,
        description: 'Contacts',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'group',
      }
    }
  },
  {
    path: 'import',
    component: ContactIntegrationComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ContactGroup,
      package: [ModulesEnum.PrivateContactModule],
      permissions: [RolesEnum.PrivateContact_View, RolesEnum.PrivateContact_Edit, RolesEnum.PrivateContact_Delete
      ],
      meta: {
        title: 'Import Contacts',
        override: true,
        description: 'Import Contacts From csv file or other providers',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'sync',
      }
    }
  },
  {
    path: 'contact',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: ':id',
            children: [
              {
                path: 'edit',
                component: ContactEditComponent,
                canActivate: [AuthGuard],
                data: {
                  menuGroup: MenuGroupEnum.ContactGroup,
                  package: [ModulesEnum.ContactModule, ModulesEnum.PrivateContactModule],
                  permissions: [RolesEnum.CompanyContact_View, RolesEnum.CompanyContact_Edit, RolesEnum.CompanyContact_Delete,
                    RolesEnum.PrivateContact_View, RolesEnum.PrivateContact_Edit, RolesEnum.PrivateContact_Delete
                  ],
                  meta: {
                    title: 'Contact Details',
                    override: true,
                    description: 'Contact details and edit page',
                    inSideMenu: false,
                    iconClass: 'material-icons',
                    iconClassCode: 'security',
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  },
];
